// libs
import React, { useCallback, useState } from 'react';

import { cn } from '@lyearn/style';
import * as ContentList from '@/components/ContentList';
// components
import ScorecardPreviewModal from '@/modules/corporate/modules/scorecards/components/ScorecardPreviewModal';
import ScorecardViewer from '@/modules/corporate/modules/scorecards/components/ScorecardViewer';
import { ScorecardFragment } from '@/modules/corporate/modules/scorecards/graphql/fragments/generated/Scorecard';

// hooks
import useScorecards from '../../hooks/useScorecards';
import ScorecardActionMenu, { ScorecardActionEnums } from './ScorecardActionMenu';
// style
import { scorecardStyles } from './style';

function SelectedScorecards({
  selectedScorecardIds,
  onChange,
}: {
  selectedScorecardIds?: string[];
  onChange: (scorecardIds?: string[]) => void;
}) {
  const [previewScorecard, setPreviewScorecard] = useState<ScorecardFragment | null>(null);
  const closePreviewModal = useCallback(() => setPreviewScorecard(null), [setPreviewScorecard]);
  const { scorecards: selectedScorecards } = useScorecards({
    ids: selectedScorecardIds,
  });

  const onAction = useCallback(
    (actionType: ScorecardActionEnums, scorecard: ScorecardFragment) => {
      switch (actionType) {
        case ScorecardActionEnums.Preview:
          setPreviewScorecard(scorecard);
          break;
        case ScorecardActionEnums.Remove:
          {
            const newScorecards = selectedScorecards?.filter((card) => card.id !== scorecard.id);
            onChange(newScorecards?.map((scorecard) => scorecard.id));
          }
          break;
        default:
      }
    },
    [onChange, selectedScorecards],
  );

  return (
    <>
      <ContentList.Provider items={selectedScorecards}>
        <ContentList.Items
          renderer={(index) => {
            const currentScorecard = selectedScorecards?.[index];
            if (!currentScorecard) {
              return null;
            }

            return (
              <ScorecardViewer
                key={currentScorecard.id}
                actionMenu={
                  <ScorecardActionMenu scorecard={currentScorecard} onAction={onAction} />
                }
                className={cn('mb-12', scorecardStyles)}
                scorecard={currentScorecard}
              />
            );
          }}
        />
      </ContentList.Provider>
      {previewScorecard ? (
        <ScorecardPreviewModal scorecard={previewScorecard} onClose={closePreviewModal} />
      ) : null}
    </>
  );
}

export default SelectedScorecards;
